import React from 'react';
import { Countdown } from './Countdown';
import { TrustBadges } from './TrustBadges';
import { FadeIn } from './FadeIn';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[100svh] flex flex-col justify-center items-center px-4 py-4 sm:py-6 overflow-hidden blueprint-grid" data-id="element-79">
      {/* Subtle glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-electric/10 rounded-full blur-[120px] pointer-events-none" data-id="element-80" />

      <div className="max-w-3xl mx-auto w-full relative z-10 flex flex-col items-center text-center gap-4 sm:gap-5" data-id="element-81">
        <FadeIn className="w-full flex justify-center" data-id="element-82">
          <div className="inline-flex items-center gap-2 sm:gap-3 border-b border-electric/30 pb-1.5 px-3" data-id="element-83">
            <span className="w-1.5 h-1.5 bg-electric rounded-full" data-id="element-84" />
            <span className="font-mono text-[10px] sm:text-xs text-carbon-300 uppercase tracking-widest" data-id="element-85">
              Método Hybrid 360™ — Sistema de Entrenamiento Completo
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} className="w-full text-center" data-id="element-86">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-display text-white leading-[0.95] tracking-normal text-balance uppercase" data-id="element-87">
            Sos profe híbrido
            <br data-id="element-88" />
            <span className="text-electric" data-id="element-89">
              Resolvé todas tus clases con este pack
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} className="w-full max-w-2xl text-center" data-id="element-90">
          <p className="text-sm sm:text-base text-carbon-300 font-sans leading-snug text-balance" data-id="element-91">
            Si entrenás hace meses sin ver resultados claros, combinás fuerza y
            cardio sin sistema y no sabés por qué tu cuerpo no avanza, esto fue
            hecho para vos.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} className="w-full flex flex-col items-center" data-id="element-92">
          <div className="relative" data-id="element-93">
            <div className="absolute inset-0 bg-electric/10 blur-[100px] rounded-full pointer-events-none" data-id="element-94" />
            <img src="https://cdn.magicpatterns.com/uploads/oPmsU86qE34SdAAycBhbJh/imagen_.png" alt="Pack completo Método Hybrid 360: los 6 tomos, bonos y guías en formato físico y digital" className="relative w-auto max-h-[26vh] sm:max-h-[30vh] h-auto mx-auto rounded-2xl" loading="eager" data-id="element-95" />
          </div>
          <div className="flex flex-wrap justify-center gap-2 mt-3" data-id="element-96">
            {['6 TOMOS', '5 BONOS', 'SISTEMA COMPLETO'].map(tag => <span key={tag} className="font-mono text-[10px] text-electric uppercase tracking-widest border border-electric/20 bg-electric/5 px-2.5 py-0.5 rounded-full" data-id="element-97">
                {tag}
              </span>)}
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="flex flex-col items-center gap-3 w-full max-w-md" data-id="element-98">
          <Countdown data-id="element-99" />

          <button onClick={scrollToPricing} className="w-full bg-electric hover:bg-electric-hover text-carbon-950 px-6 py-3.5 rounded-2xl flex flex-col items-center justify-center transition-all group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric focus-visible:ring-offset-2 focus-visible:ring-offset-carbon-950" data-id="element-100">
            <span className="flex items-center gap-2 sm:gap-3 font-display text-xl sm:text-2xl tracking-wide uppercase" data-id="element-101">
              QUIERO EL MÉTODO AHORA
              <ArrowRightIcon className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-1 transition-transform" strokeWidth={2.5} data-id="element-102" />
            </span>
            <span className="font-mono text-[10px] sm:text-xs font-semibold tracking-widest mt-0.5 opacity-80 uppercase" data-id="element-103">
              Precio de lanzamiento — Acceso inmediato
            </span>
          </button>

          <TrustBadges data-id="element-104" />
        </FadeIn>
      </div>
    </section>;
}